import { render } from "./DynamicFormModal.vue?vue&type=template&id=e645c8cc"
import script from "./DynamicFormModal.vue?vue&type=script&lang=js"
export * from "./DynamicFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__